<template>
  <div class="fshr-gridVue">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="less">
@import "../../less/components/_component-grid";
</style>
